export default __webpack_public_path__ + "static/media/AVX460.7e70c981.png";